// Campaign type detection for imported campaigns (#6612). Classifying an imported external campaign is tracked as
// its own task, so a classification that failed can be told apart from one that has not run yet. Pure function,
// used next to the Campaign Type picker.
import type { CampaignData, TaskTrackingSummary } from '@/lib/types';

/** The goal an imported external campaign carries until it has a type. */
export const UNCLASSIFIED_GOAL = 'external';

/**
 * Whether the campaign page should say that type detection failed.
 *
 * Only for an imported external campaign still waiting on a type, whose classification has failed and is not
 * being retried right now. A campaign typed since, by a later classification or by hand, never shows it.
 */
export function classificationFailed(
  campaign: Pick<CampaignData, 'origin' | 'goal'>,
  classification: TaskTrackingSummary | undefined,
): boolean {
  return (
    campaign.origin === 'external' &&
    campaign.goal === UNCLASSIFIED_GOAL &&
    !!classification &&
    classification.failed > 0 &&
    classification.in_progress === 0
  );
}
